{
  "primary": "#5b91df",
  "secondary": "#427bc2",
  "symbolViewBox": "0 0 100 100",
  "wordmark": {
    "viewBox": "0 0 686 148",
    "symbolTransform": "translate(113.4167 45.9167) scale(1.041667)",
    "letters": [
      {
        "name": "b-first",
        "path": "M0 0H10.8V66.9620A50 50 0 1 1 0 98ZM10.8 98A39.2 39.2 0 1 0 89.2 98A39.2 39.2 0 1 0 10.8 98Z",
        "transform": "translate(0 0)",
        "tone": "primary"
      },
      {
        "name": "b-last",
        "path": "M0 0H10.8V66.9620A50 50 0 1 1 0 98ZM10.8 98A39.2 39.2 0 1 0 89.2 98A39.2 39.2 0 1 0 10.8 98Z",
        "transform": "translate(231 0)",
        "tone": "primary"
      },
      {
        "name": "d",
        "path": "M100 0H89.2V66.9620A50 50 0 1 0 100 98ZM10.8 98A39.2 39.2 0 1 0 89.2 98A39.2 39.2 0 1 0 10.8 98Z",
        "transform": "translate(368 0)",
        "tone": "secondary"
      },
      {
        "name": "o",
        "path": "M0 98A50 50 0 1 0 100 98A50 50 0 1 0 0 98ZM10.8 98A39.2 39.2 0 1 0 89.2 98A39.2 39.2 0 1 0 10.8 98Z",
        "transform": "translate(477 0)",
        "tone": "secondary"
      },
      {
        "name": "c",
        "path": "M85.3553 62.6447A50 50 0 1 0 85.3553 133.3553L77.7186 125.7186A39.2 39.2 0 1 1 77.7186 70.2814Z",
        "transform": "translate(586 0)",
        "tone": "secondary"
      }
    ]
  },
  "material": {
    "stops": [0, 0.27, 0.68, 1],
    "frontStroke": 0.55,
    "dark": ["#7aa4da", "#548acf", "#427bc2", "#3565a1"],
    "staticStroke": 0.3,
    "light": ["#8db5eb", "#6b9fe4", "#5b91df", "#4679bd"],
    "rim": [
      {
        "offset": 0,
        "color": "#c5daf6",
        "opacity": 0.6
      },
      {
        "offset": 0.45,
        "color": "#8eb2e2",
        "opacity": 0.35
      },
      {
        "offset": 1,
        "color": "#366bad",
        "opacity": 0.7
      }
    ]
  },
  "bands": [
    "M20.6742 12.0000 A48 48 0 0 1 79.3258 12.0000 C59.7753 3.0417 40.2247 20.9583 20.6742 12.0000Z",
    "M20.6742 12.0000 C40.2247 20.9583 59.7753 3.0417 79.3258 12.0000 A48 48 0 0 1 93.6348 30.0000 C64.5449 10.1667 35.4551 49.8333 6.3652 30.0000 A48 48 0 0 1 20.6742 12.0000Z",
    "M6.3652 30.0000 C35.4551 49.8333 64.5449 10.1667 93.6348 30.0000 A48 48 0 0 1 97.9896 49.0000 C65.9965 25.0104 34.0035 72.9896 2.0104 49.0000 A48 48 0 0 1 6.3652 30.0000Z",
    "M2.0104 49.0000 C34.0035 72.9896 65.9965 25.0104 97.9896 49.0000 A48 48 0 0 1 94.4972 68.0000 C64.8324 47.3750 35.1676 88.6250 5.5028 68.0000 A48 48 0 0 1 2.0104 49.0000Z",
    "M5.5028 68.0000 C35.1676 88.6250 64.8324 47.3750 94.4972 68.0000 A48 48 0 0 1 82.8481 85.0000 C60.9494 73.7604 39.0506 96.2396 17.1519 85.0000 A48 48 0 0 1 5.5028 68.0000Z",
    "M17.1519 85.0000 C39.0506 96.2396 60.9494 73.7604 82.8481 85.0000 A48 48 0 0 1 17.1519 85.0000Z"
  ],
  "seams": [
    "M20.6742 12.0000 C40.2247 20.9583 59.7753 3.0417 79.3258 12.0000",
    "M6.3652 30.0000 C35.4551 49.8333 64.5449 10.1667 93.6348 30.0000",
    "M2.0104 49.0000 C34.0035 72.9896 65.9965 25.0104 97.9896 49.0000",
    "M5.5028 68.0000 C35.1676 88.6250 64.8324 47.3750 94.4972 68.0000",
    "M17.1519 85.0000 C39.0506 96.2396 60.9494 73.7604 82.8481 85.0000"
  ],
  "seamWidth": 2.3
}
